import { useCallback, useMemo } from 'react';
import Link from 'next/link';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import BasePopup from '@r1-frontend/ui-react/components/popups/basePopup';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { isLeadGenerationHide } from '~/src/helpers/isLeadGenerationHide';

import * as ST from './styled';

interface IProps {
    isOpen: boolean,
    onClose: () => void,
    title: string,
    showRequestFormPopup: () => void,
    isMobile: boolean,
}

const CLIENT_REFERRAL_LINK = '/bundles';

const ConnectDomruPopup = ({ isOpen, onClose, title, showRequestFormPopup, isMobile }: IProps): JSX.Element => {
    const isLeadGeneration = useMemo(() => isLeadGenerationHide(), []);

    const onClickReferralButton = useCallback(() => {
        if (location.pathname === CLIENT_REFERRAL_LINK) {
            onClose();
        } else {
            dataLayerPush({
                category: CATEGORIES.applicationForm,
                event: EVENTS.UAevent,
                action: ACTIONS.move,
                label: CLIENT_REFERRAL_LINK,
            });
        }
    }, [onClose]);

    const onShowRequestFormPopup = useCallback(() => {
        dataLayerPush({
            category: CATEGORIES.applicationForm,
            event: EVENTS.UAevent,
            action: ACTIONS.move,
            label: '[default_callback]',
        });
        showRequestFormPopup();
        onClose();
    }, [showRequestFormPopup, onClose]);

    return (
        <BasePopup
            title={title}
            onClose={onClose}
            isOpen={isOpen}
            width={'600px'}
            height={'auto'}
            fullWidth={true}
            customScrollBarStyles={{
                view: {
                    position: 'relative',
                    paddingBottom: !isMobile ? 0 : '8px',
                },
            }}
            customBasePopupStyles={{
                topWrapper: {
                    paddingBottom: 0,
                },
            }}
            customDefaultPopupStyles={{
                popup: {
                    mobile: {
                        width: '308px !important',
                        backgroundImage: "url('/static/images/connect-domru/bg.mobile.png')",
                    },
                    default: {
                        backgroundImage: "url('/static/images/connect-domru/bg.desktop.png')",
                        backgroundPosition: 'top',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                    },
                },
            }}
            data-test='become-client-popup'
        >
            <ST.Wrapper>
                <div id={'topBlock'}>
                    <Paragraph4>
                        Оформите заявку онлайн за пару минут
                        <br />
                        <br />
                    </Paragraph4>
                    <Link
                        href={CLIENT_REFERRAL_LINK}
                        prefetch={false}
                        passHref
                        data-test='one-rouble-link'
                    >
                        <Button onClick={onClickReferralButton}>Выбрать тариф</Button>
                    </Link>
                </div>
                <div id={'bottomBlock'}>
                    {!isLeadGeneration &&
                        <>
                            <Paragraph4>Сложно определиться? Можем позвонить и помочь вам выбрать подходящий тариф!</Paragraph4>
                            <Button bType={'secondary'} onClick={onShowRequestFormPopup}>Позвоните мне</Button>
                        </>
                    }
                </div>
            </ST.Wrapper>
        </BasePopup>
    );
};

export default ConnectDomruPopup;
